<template>
    <div>
        <div class="proadd1">商品列表/商品修改</div>
        <div class="proadd2">
            <div class="proadd3">基础信息</div>
            <div class="proadd4"></div>
            <div class="proadd5">
                <div class="proadd6-1">产品图片：</div>
                <div class="proadd9" style="position: relative">
                    <img src="@/assets/images/qw3.png" class="proadd10" alt="" v-if="url == ''">
                    <img :src="url" class="proadd10" alt="" v-else>
                    <Upload
                        class="proadd11"
                        :on-success="succGzs"
                        :multiple="false"
                        type="drag"
                        action="/load/gyy/api/uploadfile">
                        <div>
                        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                        <p>点击或者拖拽以上传图片</p>
                        </div>
                    </Upload>
                    <span class="proadd8" style="position: absolute;left: 100px;">此项为必填项</span>
                </div>
            </div>
            <div class="proadd5">
                <div class="proadd6-1">商品名称：</div>
                <input v-model="name" type="text" placeholder="请输入产品名称" class="proadd7">
                <span class="proadd8">此项为必填项</span>
            </div>
            <div class="proadd5">
                <div class="proadd6-1">商品编码：</div>
                <input v-model="code" type="text" placeholder="请输入产品编码" class="proadd7">
                <span class="proadd8">此项为必填项</span>
            </div>
            <div class="proadd5">
                <div class="proadd6-1">商品型号：</div>
                <input v-model="model" type="text" placeholder="请输入产品型号" class="proadd7">
                <span class="proadd8">此项为必填项</span>
            </div>
            <div class="proadd5">
                <div class="proadd6-1">商品规格：</div>
                <input v-model="specs" type="text" placeholder="请输入产品规格" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">商品单位：</div>
                <input v-model="unit" type="text" placeholder="请输入产品单位" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">商品价格：</div>
                <input v-model="price" type="text" placeholder="请输入产品价格" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">商品分类：</div>
                <div class="proadd9">
                    <el-select v-model="sortidName" class="proadd9-1" @change="yjxz" filterable placeholder="请选择商品分类">
                        <el-option
                        label="请选择"
                        value="请选择">
                        </el-option>
                        <el-option
                        v-for="(item,index) in yjArr"
                        :key="'yj'+index"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="sortid2Name" @change="eryjxz" class="proadd9-1" filterable placeholder="请选择商品分类">
                        <el-option
                        v-for="(item,index) in erArr"
                        :key="'ej'+index"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <span class="proadd8">此项为必填项</span>
                </div>
            </div>
            <!-- <div class="proadd5">
                <div class="proadd6-1">单次领用限制：</div>
                <input v-model="limitnum" type="text" placeholder="请输入数量" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">加工寿命：</div>
                <input v-model="toollife" type="text" placeholder="请输入加工寿命" class="proadd7">
            </div> -->

        </div>
        <div class="" style="margin-top:20px;height: 350px;width: 100%;background-color: #fff;">
            <div class="proadd3">ERP信息</div>
            <div class="proadd4"></div>
            <div class="proadd5">
                <div class="proadd6-1">ERP货号编码：</div>
                <input v-model="erpcode" type="text" placeholder="请输入erp货号编码" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">ERP基础单位编码：</div>
                <input v-model="erpbaseunit" type="text" placeholder="请输入erp基础单位编码" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">ERP单位编码：</div>
                <input v-model="erpunit" type="text" placeholder="请输入erp单位编码" class="proadd7">
            </div>
        </div>

        <div class="" style="margin-top:20px;height: 100%;width: 100%;background-color: #fff;">
            <div class="proadd3">
                <div>其他信息</div>
                <div class="proadd3-2" @click="addQita">
                    <img class="imgs" src="@/assets/imgs/38.png" alt="">
                    <div>添加</div>
                </div>
            </div>
            <div class="proadd4"></div>
            <Table border ref="selection" :columns="columns7" :data="item.list" :loading="loading">
                <template slot-scope="{ row }" slot="action">
                    <button class="editcao1" @click="edits(row)">
                        <div class="editcao1-1">
                            <img class="imgs" src="@/assets/imgs/20.png" alt="">
                            <div>修改</div>
                        </div>
                    </button>
                    <button style="margin-left: 10px;" class="editcao2" @click="dels(row)">
                        <div class="editcao2-1">
                            <img class="imgs" src="@/assets/imgs/39.png" alt="">
                            <div>删除</div>
                        </div>
                    </button>
                </template>
            </Table>
            <!-- <div class="proadd5">
                <div class="proadd6-1">组织架构：</div>
                <div class="proadd9">
                    <el-select v-model="zuzhi" @change="zuzhixz" class="proadd9-1" filterable placeholder="请选择组织架构">
                        <el-option
                        label="请选择"
                        value="请选择">
                        </el-option>
                        <el-option
                        v-for="(item,index) in companyList"
                        :key="'zuz'+index"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="erzuzhi" @change="erjizuzhixz" class="proadd9-1" filterable placeholder="请选择组织架构">
                        <el-option
                        v-for="(item,index) in erjiCompanyList"
                        :key="'ej'+index"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="proadd5">
                <div class="proadd6-1">加工设备型号：</div>
                <input v-model="sbspecs" type="text" placeholder="请输入加工设备型号" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">加工工序名称：</div>
                <input v-model="procedurename" type="text" placeholder="请输入加工工序名称" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">加工工序号：</div>
                <input v-model="procedurecode" type="text" placeholder="请输入加工工序号" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">加工产品名称：</div>
                <input v-model="productname" type="text" placeholder="请输入加工产品名称" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">加工产品编码：</div>
                <input v-model="productcode" type="text" placeholder="请输入加工产品编码" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">加工产品图号：</div>
                <input v-model="figurecode" type="text" placeholder="请输入加工产品图号" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">月度生产计划：</div>
                <input v-model="productionplan" type="text" placeholder="请输入月度生产计划" class="proadd7">
            </div>
            <div class="proadd5">
                <div class="proadd6-1">月度需求计划：</div>
                <input v-model="quantitydemanded" type="text" placeholder="请输入月度需求计划" class="proadd7">
            </div> -->
        </div>
        <div class="proadd12">
            <div class="proadd12-1" @click="fanhui">返回</div>
            <div class="proadd12-2" @click="confires">确定</div>
        </div>
        <!-- 其他信息修改 -->
        <xc-model :loading="editModel" title="修改其他信息" :is_buttom="false" @cancel="cancels">
            <div slot="mbody">
                <div class="proadd13">
                <div style="margin-top: 0">
                    <div class="proadd5" style="margin-left: 35px;">
                        <div class="proadd6-1s">组织架构：</div>
                        <div class="proadd9">
                            <el-select v-model="zuzhi" style="border: none;" @change="zuzhixz" class="proadd9-1" filterable placeholder="请选择组织架构">
                                <el-option
                                label="请选择"
                                value="请选择">
                                </el-option>
                                <el-option
                                v-for="(item,index) in companyList"
                                :key="'zuz'+index"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工寿命：</div>
                        <input type="text" v-model="toollife" placeholder="请输入加工寿命" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">单次领用限制：</div>
                        <input type="text" v-model="limitnum" placeholder="请输入单次领用限制" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">设备型号：</div>
                        <input type="text" v-model="sbspecs" placeholder="请输入设备型号" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">工序名称：</div>
                        <input type="text" v-model="procedurename" placeholder="请输入工序名称" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">工序号：</div>
                        <input type="text" v-model="procedurecode" placeholder="请输入工序名称" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工产品名称：</div>
                        <input type="text" v-model="productname" placeholder="请输入加工产品名称" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工产品编码：</div>
                        <input type="text" v-model="productcode" placeholder="请输入加工产品编码" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工产品图号：</div>
                        <input type="text" v-model="figurecode" placeholder="请输入加工产品图号" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">月度生产计划：</div>
                        <input type="text" v-model="productionplan" placeholder="请输入月度生产计划" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">月度需求计划：</div>
                        <input type="text" v-model="quantitydemanded" placeholder="请输入月度需求计划" class="proadd15s">
                    </div>
                </div> 
                <div class="proadd16" style="margin-top: 10px;">
                    <div class="proadd17" @click="sures">确定</div>
                    <div class="proadd17" style="margin-left: 50px" @click="cancels">取消</div>
                </div>
                </div>
            </div>
        </xc-model>
        <!-- 其他信息添加 -->
        <xc-model :loading="addModel" title="添加其他信息" :is_buttom="false" @cancel="addcancels">
            <div slot="mbody">
                <div class="proadd13">
                <div style="margin-top: 0">
                    <div class="proadd5" style="margin-left: 35px;">
                        <div class="proadd6-1s">组织架构：</div>
                        <div class="proadd9">
                            <el-select v-model="zuzhi" style="border: none;" @change="zuzhixz" class="proadd9-1" filterable placeholder="请选择组织架构">
                                <el-option
                                label="请选择"
                                value="请选择">
                                </el-option>
                                <el-option
                                v-for="(item,index) in companyList"
                                :key="'zuz'+index"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工寿命：</div>
                        <input type="text" v-model="toollife" placeholder="请输入加工寿命" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">单次领用限制：</div>
                        <input type="text" v-model="limitnum" placeholder="请输入单次领用限制" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">设备型号：</div>
                        <input type="text" v-model="sbspecs" placeholder="请输入设备型号" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">工序名称：</div>
                        <input type="text" v-model="procedurename" placeholder="请输入工序名称" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">工序号：</div>
                        <input type="text" v-model="procedurecode" placeholder="请输入工序名称" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工产品名称：</div>
                        <input type="text" v-model="productname" placeholder="请输入加工产品名称" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工产品编码：</div>
                        <input type="text" v-model="productcode" placeholder="请输入加工产品编码" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">加工产品图号：</div>
                        <input type="text" v-model="figurecode" placeholder="请输入加工产品图号" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">月度生产计划：</div>
                        <input type="text" v-model="productionplan" placeholder="请输入月度生产计划" class="proadd15s">
                    </div>
                    <div style="display: flex;display: flex;justify-content: center;margin-top: 10px">
                        <div class="proadd14s">月度需求计划：</div>
                        <input type="text" v-model="quantitydemanded" placeholder="请输入月度需求计划" class="proadd15s">
                    </div>
                </div> 
                <div class="proadd16" style="margin-top: 10px;">
                    <div class="proadd17" @click="addsures">确定</div>
                    <div class="proadd17" style="margin-left: 50px" @click="addcancels">取消</div>
                </div>
                </div>
            </div>
        </xc-model>
        <!-- 其他信息删除 -->
        <xc-model :loading="delModel" title="删除其他信息" :is_buttom="false" @cancel="delcancels">
            <div slot="mbody">
                <div class="proadd13">
                <div style="text-align: center;font-size: 18px;">此操作将永久删除该条信息，是否继续删除？</div> 
                <div class="proadd16" style="margin-top: 40px;">
                    <div class="proadd17" @click="delsures">确定</div>
                    <div class="proadd17" style="margin-left: 50px" @click="delcancels">取消</div>
                </div>
                </div>
            </div>
        </xc-model>
    </div>
</template>

<script>
    import https from '@/api/schemaSequence';
    import httpUser from "@/api/user";
    import util from '@/util/util';
    export default {
        data(){
            return{
                addModel:false,
                delModel:false,
                loading:false,
                detailId:'',
                orgnameId:'',
                columns7:[
                    {
                        title: '组织架构',
                        width: 200,
                        align: 'center',
                        key: 'orgname'
                    },
                    {
                        title: '加工寿命',
                        width: 200,
                        align: 'center',
                        key: 'toollife'
                    },
                    {
                        title: '单次领用限制',
                        width: 200,
                        align: 'center',
                        key: 'limitnum'
                    },
                    {
                        title: '设备型号',
                        width: 200,
                        align: 'center',
                        key: 'sbspecs'
                    },
                    {
                        title: '工序名称',
                        width: 200,
                        align: 'center',
                        key: 'procedurename'
                    },
                    {
                        title: '工序号',
                        width: 200,
                        align: 'center',
                        key: 'procedurecode'
                    },
                    {
                        title: '加工产品名称',
                        width: 200,
                        align: 'center',
                        key: 'productname'
                    },
                    {
                        title: '加工产品编码',
                        width: 200,
                        align: 'center',
                        key: 'productcode'
                    },
                    {
                        title: '加工产品图号',
                        width: 200,
                        align: 'center',
                        key: 'figurecode'
                    },
                    {
                        title: '月度生产计划',
                        width: 200,
                        align: 'center',
                        key: 'productionplan'
                    },
                    {
                        title: '月度需求计划',
                        width: 200,
                        align: 'center',
                        key: 'quantitydemanded'
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 250,
                        align: 'center'
                    }
                ],
                editModel:false,
                names:'',
                item:'',
                name:'',
                url:'',
                code:'',
                specs:'',
                model:'',
                price:'',
                sortid:'',
                sortidName:'',
                sortid2:'',
                sortid2Name:'',
                limitnum:'',
                toollife:'',
                erpcode:'',
                erpbaseunit:'',
                erpunit:'',
                unit:'',
                zuzhi:'',
                erzuzhi:'',
                procedurecode:'',
                procedurename:'',
                productname:'',
                productcode:'',
                figurecode:'',
                productionplan:'',
                quantitydemanded:'',
                sbspecs:'',
                user:'',
                yjArr:[],
                erArr:[],
                companyList:[],
                erjiCompanyList:[],
                orgid:'',
                orgid1:'',
                id:'',
                delId:''
            }
        },
        mounted(){
            this.user = JSON.parse(sessionStorage.getItem('user'));
            let data = {
                companyid:this.user.companyId,
                pid:0,
                page:1,
                pageSize:10000,
                }
            httpUser.getgoodssortlist(data).then(res1=>{
                this.yjArr = res1.data.dataList;
            })
            let data1 = {
                companyId:this.user.companyId,
                pid:0
            }
            https.orgListSearch(data1).then(res=>{
                let datas = {
                    companyId:res.data.orglist[0].companyId,
                    pid:res.data.orglist[0].id
                };
                https.orgListSearch(datas).then(re=>{
                    this.companyList = re.data.orglist
                })
            })
            this.item = JSON.parse(this.$route.query.item)
            // console.log(this.item,'this.item')
            this.url = this.item.url;
            this.id = this.item.id;
            this.name = this.item.name;
            this.code = this.item.code;
            this.specs = this.item.specs;
            this.model = this.item.model;
            this.unit = this.item.unit;
            this.price = this.item.price;
            this.sortid = this.item.sortid;
            this.sortid2 = this.item.sortid2;
            this.sortidName = this.item.sortname;
            this.sortid2Name = this.item.sortname2;
            this.limitnum = this.item.limitnum;
            this.toollife = this.item.toollife;
            this.erpcode = this.item.erpcode;
            this.erpbaseunit = this.item.erpbaseunit;
            this.erpunit = this.item.erpunit;
            this.zuzhi = this.item.orgname;
            this.erzuzhi = this.item.orgname2;
            this.sbspecs = this.item.sbspecs;
            this.procedurename = this.item.procedurename;
            this.procedurecode = this.item.procedurecode;
            this.productname = this.item.productname;
            this.productcode = this.item.productcode;
            this.figurecode = this.item.figurecode;
            this.productionplan = this.item.productionplan;
            this.quantitydemanded = this.item.quantitydemanded;
            this.orgid = this.item.orgid2;
            this.orgid1 = this.item.orgid;
            let data2 = {
                    companyid:this.user.companyId,
                    pid:this.sortid,
                    page:1,
                    pageSize:10000,
                }
            httpUser.getgoodssortlist(data2).then(res => {
                this.erArr = res.data.dataList;
            })
            let data3 = {
                companyId:this.user.companyId,
                pid:this.orgid1
            }
            https.orgListSearch(data3).then(res=>{
                this.erjiCompanyList = res.data.orglist
            })
        },
        methods:{
            dels(row){
                this.delId = row.id
                this.delModel = true;
            },
            delsures(){
                let data = {
                    id:this.delId
                }
                https.deletecupgoodsdetail(data).then(res=>{
                    if(res.code == '0000') {
                        this.$message.success('删除成功');
                        setTimeout(()=> {
                            this.$router.back();
                        }, 1000);
                    }
                })
            },
            delcancels(){
                this.delModel = false;
            },
            addQita(){
                this.addModel = true;
            },
            addsures(){
                let data = {
                    id:'',
                    goodsid:this.id,
                    figurecode:this.figurecode,
                    limitnum:this.limitnum,
                    orgid:this.orgnameId,
                    procedurecode:this.procedurecode,
                    procedurename:this.procedurename,
                    productcode:this.productcode,
                    productname:this.productname,
                    toollife:this.toollife,
                    productionplan:this.productionplan,
                    quantitydemanded:this.quantitydemanded,
                    sbspecs:this.sbspecs
                };
                https.addorupdatecupgoodsdetail(data).then(res=>{
                    if(res.code == '0000') {
                        this.$message.success("添加成功")
                        this.addModel = false;
                        this.zuzhi = '';
                        this.sbspecs = '';
                        this.procedurename = '';
                        this.productname = '';
                        this.productcode = '';
                        this.figurecode = '';
                        this.productionplan = '';
                        this.quantitydemanded = '';
                        this.limitnum = '';
                        this.toollife = '';
                        this.editModel = false;
                        this.loading = false;
                        setTimeout(()=> {
                            this.$router.back();
                        }, 1000);
                    }else if(res.code == '1001'){
                        this.$message.error('已有重复工序');
                    }else if(res.code == '1111'){
                        this.$message.error('没有该商品详情');
                    }
                })
            },
            addcancels(){
                this.addModel = false;
                this.zuzhi = '';
                this.sbspecs = '';
                this.procedurename = '';
                this.productname = '';
                this.productcode = '';
                this.figurecode = '';
                this.productionplan = '';
                this.quantitydemanded = '';
                this.limitnum = '';
                this.toollife = '';
                this.procedurecode = ''
            },
            edits(row){
                this.editModel = true
                this.zuzhi = row.orgname   
                this.sbspecs = row.sbspecs   
                this.procedurename = row.procedurename 
                this.procedurecode = row.procedurecode  
                this.productname = row.productname   
                this.productcode = row.productcode   
                this.figurecode = row.figurecode   
                this.productionplan = row.productionplan   
                this.quantitydemanded = row.quantitydemanded
                this.limitnum = row.limitnum
                this.toollife = row.toollife   
                this.detailId = row.id
                this.orgnameId = row.orgid
            },
            sures(){
                let data = {
                    id:this.detailId,
                    // id:'',
                    goodsid:this.id,
                    figurecode:this.figurecode,
                    limitnum:this.limitnum,
                    orgid:this.orgnameId,
                    procedurecode:this.procedurecode,
                    procedurename:this.procedurename,
                    productcode:this.productcode,
                    productname:this.productname,
                    toollife:this.toollife,
                    productionplan:this.productionplan,
                    quantitydemanded:this.quantitydemanded,
                    sbspecs:this.sbspecs
                }
                https.addorupdatecupgoodsdetail(data).then(res=>{
                    if(res.code == '0000') {
                        this.$message.success("修改成功")
                        this.editModel = false;
                        this.loading = false;
                        setTimeout(()=> {
                            this.$router.back();
                        }, 1000);
                    }else if(res.code == '1001'){
                        this.$message.error('已有重复工序');
                    }else if(res.code == '1111'){
                        this.$message.error('没有该商品详情');
                    }
                })
            },
            cancels(){
                this.editModel = false;
                this.zuzhi = '';
                this.sbspecs = '';
                this.procedurename = '';
                this.productname = '';
                this.productcode = '';
                this.figurecode = '';
                this.productionplan = '';
                this.quantitydemanded = '';
                this.limitnum = '';
                this.toollife = '';
                this.procedurecode = ''
            },
            confires(){
                if (this.url == '' || this.url == null) {
                    this.$message.error('请先上传产品图片');
                    return false;
                }
                if (this.name == '') {
                    this.$message.error('商品名称不能为空');
                    return false;
                }
                if (this.code == '' || util.checkSpace(this.code) || util.noBq().test(this.code)) {
                    this.$message.error('商品编码不能为空并不能含有空格或者符号');
                    return false;
                }
                if (this.model == '') {
                    this.$message.error('商品型号不能为空');
                    return false;
                }
                // if (this.specs == '' || util.checkSpace(this.specs) || util.noBq().test(this.specs)) {
                //     this.$message.error('商品规格不能为空并不能含有空格或者符号');
                //     return false;
                // }
                if (util.checkSpace(this.unit) || util.noBq().test(this.unit)) {
                    this.$message.error('商品单位不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.price) || util.noBq().test(this.price)) {
                    this.$message.error('商品价格不能含有空格或者符号');
                    return false;
                }
                // if (this.price == '' || util.checkSpace(this.price) || util.noBq().test(this.price)) {
                //     this.$message.error('商品价格不能为空并不能含有空格或者符号');
                //     return false;
                // }
                if (this.sortidName == '' || this.sortidName == '请选择' || this.sortid2Name == '' || this.sortid2Name == '请选择') {
                    this.$message.error('请选择商品分类');
                    return false;
                }
                if (util.checkSpace(this.limitnum) || util.noBq().test(this.limitnum)) {
                    this.$message.error('数量不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.toollife) || util.noBq().test(this.toollife)) {
                    this.$message.error('加工寿命不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.erpcode) || util.noBq().test(this.erpcode)) {
                    this.$message.error('ERP货号编码不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.erpbaseunit) || util.noBq().test(this.erpbaseunit)) {
                    this.$message.error('ERP基础单位编码不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.erpunit) || util.noBq().test(this.erpunit)) {
                    this.$message.error('ERP单位编码不能含有空格或者符号');
                    return false;
                }
                if (this.zuzhi == '请选择' || this.erzuzhi == '请选择') {
                    me.$message.error('请选择组织架构');
                    return false;
                }
                if (util.checkSpace(this.sbspecs) || util.noBq().test(this.sbspecs)) {
                    this.$message.error('加工设备型号不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.procedurename) || util.noBq().test(this.procedurename)) {
                    this.$message.error('加工工序名称不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.procedurecode) || util.noBq().test(this.procedurecode)) {
                    this.$message.error('加工工序号不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.productname) || util.noBq().test(this.productname)) {
                    this.$message.error('加工产品名称不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.productcode) || util.noBq().test(this.productcode)) {
                    this.$message.error('加工产品编码不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.figurecode) || util.noBq().test(this.figurecode)) {
                    this.$message.error('加工产品图号不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.productionplan) || util.noBq().test(this.productionplan)) {
                    this.$message.error('月度生产计划不能含有空格或者符号');
                    return false;
                }
                if (util.checkSpace(this.quantitydemanded) || util.noBq().test(this.quantitydemanded)) {
                    this.$message.error('月度需求计划不能含有空格或者符号');
                    return false;
                }
                let data = {
                    id:this.id,
                    companyid:this.user.companyId,
                    url:this.url,
                    name:this.name,
                    code:this.code,
                    specs:this.specs,
                    model:this.model,
                    unit:this.unit,
                    price:this.price,
                    sortid:this.sortid,
                    sortid2:this.sortid2,
                    limitnum:this.limitnum,
                    toollife:this.toollife,
                    erpcode:this.erpcode,
                    erpbaseunit:this.erpbaseunit,
                    erpunit:this.erpunit,
                    orgid:this.orgid,
                    sbspecs:this.sbspecs,
                    procedurename:this.procedurename,
                    procedurecode:this.procedurecode,
                    productname:this.productname,
                    productcode:this.productcode,
                    figurecode:this.figurecode,
                    productionplan:this.productionplan,
                    quantitydemanded:this.quantitydemanded,
                }
                https.addorupdatecupgoodsbyorg(data).then(res=>{
                    if(res.code == '0000'){
                        this.$message.success('已修改商品')
                        setTimeout(()=> {
                            this.$router.back()
                        }, 500);
                    }else if(res.code == '1001') {
                        this.$message.error('商品编码重复')
                    }
                })
            },
            eryjxz(e){
                this.sortid2 = e
            },
            // 商品分类一级选择
            yjxz(e){
                if (e == '请选择') {
                    this.sortid2Name = '';
                    this.erArr = [];
                    return false;
                }
                this.sortid2Name = '';
                this.erArr = [];
                this.sortid = e
                let data = {
                    companyid:this.user.companyId,
                    pid:e,
                    page:1,
                    pageSize:10000,
                }
                httpUser.getgoodssortlist(data).then(res => {
                    this.erArr = res.data.dataList;
                })
            },
            // 组织架构一级选择
            zuzhixz(e){
                this.orgnameId = e
                this.erzuzhi = ''
                let data1 = {
                    companyId:this.user.companyId,
                    pid:e
                }
                https.orgListSearch(data1).then(res=>{
                    this.erjiCompanyList = res.data.orglist
                })
            },
            // 组织架构二级
            erjizuzhixz(e){
                this.orgid = e
            },
            succGzs(e){
                this.url = e.data;
            },
            fanhui(){
                this.$router.back()
            }
        }
        
    }
</script>

<style scoped>
@import 'productEdit.css'
</style>